import * as __au2ViewDef from './payment.html';
import { FieldValidationRenderer } from './../../../common/validation-renderers/field-validation-renderer';
/* eslint-disable no-prototype-builtins */
import { ValidLengthNumberPropertyRule } from './../../../common/validation-matchers/is-valid-length-number';
import { ValidYearPropertyRule } from './../../../common/validation-matchers/is-year-valid';
import { ValidNumberPropertyRule } from './../../../common/validation-matchers/is-valid-number';
import { INotification } from 'aurelia2-notification';
import { IValidationController } from '@aurelia/validation-html';
import { newInstanceForScope } from '@aurelia/kernel';
import { bindable, customElement } from 'aurelia';
import { IRouter } from '@aurelia/router';
import { IAppService } from '../../../services/app';
import { IApiService } from '../../../services/api';
import { IValidationRules } from '@aurelia/validation';

declare const CBA;

@customElement({ ...__au2ViewDef, name: 'payment' })
export class Payment {
    @bindable customerreferencenumber;
    @bindable invoiceamount;

    private presenter;

    private showBuyNowModal = false;
    private alertShow = false;
    private alertType = '';
    private acceptsCreditCardPayments;
    private acceptsPremiumFunderPayments;

    private cardName;
    private cardNumber;
    private cardExpiryMonth;
    private cardExpiryYear;
    private cardCvn;
    private showPayNowModal = false;
    private showVerifyModal = false;
    private isConfirmPayment = false;
    private cardProviderType = 'none';
    private surchargePercentage = 0;
    private expiryMonthArray = [
        { index: '', name: '' },
        { index: '01', name: 'January' },
        { index: '02', name: 'February' },
        { index: '03', name: 'March' },
        { index: '04', name: 'April' },
        { index: '05', name: 'May' },
        { index: '06', name: 'June' },
        { index: '07', name: 'July' },
        { index: '08', name: 'August' },
        { index: '09', name: 'September' },
        { index: '10', name: 'October' },
        { index: '11', name: 'November' },
        { index: '12', name: 'December' },
    ];
    private expiryYearArray = [{ index: '', name: '' }];

    private modalMessage;
    private paymentErrors = [];
    private surchargeAmount;
    private totalIncludingSurcharge;

    constructor(
        @newInstanceForScope(IValidationController)
        readonly controller: IValidationController,
        @IValidationRules readonly validationRules: IValidationRules,
        @IRouter readonly router: IRouter,
        @IAppService readonly appService: IAppService,
        @IApiService readonly api: IApiService,
        @INotification readonly notification: INotification
    ) {
        this.acceptsCreditCardPayments =
            this.appService.scheme.paymentByCreditCard;
        this.acceptsPremiumFunderPayments =
            this.appService.scheme.paymentByFunder;

        const d = new Date();
        const year = d.getFullYear();
        const month = d.getMonth();
        const day = d.getDate();

        for (let i = 0; i < 10; i++) {
            const date = new Date(year + i, month, day).getFullYear();
            this.expiryYearArray.push({
                index: date.toString().substr(-2),
                name: date as unknown as string,
            });
        }

        this.presenter = new FieldValidationRenderer();
        this.controller.addSubscriber(this.presenter);

        validationRules
            .on(this)
            .ensure((m) => m.cardName)
            .required()
            .withMessage('')
            .ensure((m) => m.cardNumber)
            .required()
            .withMessage('')
            .satisfiesRule(new ValidNumberPropertyRule('cardNumber'))
            .ensure((m) => m.cardExpiryMonth)
            .required()
            .withMessage('')
            .ensure((m) => m.cardExpiryYear)
            .required()
            .withMessage('')
            .satisfiesRule(new ValidYearPropertyRule('cardExpiryYear'))
            .ensure((m) => m.cardCvn)
            .required()
            .withMessage('')
            .satisfiesRule(new ValidLengthNumberPropertyRule('cardCvn'));
    }

    async processPayment() {
        this.alertShow = false;
        this.modalMessage = 'Processing Payment. Please Wait...';
        const validationResult = await this.controller.validate();
        if (validationResult.valid) {
            this.showPayNowModal = !this.showPayNowModal;

            const result = await this.api.postBpointPaymentAuthKey(
                this.appService.policyModel.invoiceId,
                this.cardProviderType
            );

            if (
                result.hasOwnProperty('apiResponse') &&
                result.apiResponse.responseCode === 0
            ) {
                CBA.ProcessPayment({
                    AuthKey: result.authKey,
                    CardNumber: this.cardNumber,
                    Cvn: this.cardCvn,
                    ExpiryMonth: this.cardExpiryMonth,
                    ExpiryYear: this.cardExpiryYear,
                    CardHolderName: this.cardName,
                    CallbackFunction: (result) =>
                        this.processPaymentCallBack(result),
                });
            } else {
                this.showPayNowModal = !this.showPayNowModal;

                let errorText;
                if (result < 0) {
                    switch (result) {
                        case -1:
                            errorText = 'Invalid invoice specified.';
                            break;
                        case -2:
                            errorText = 'Invalid client invoice specified.';
                            break;
                        case -3:
                            errorText = 'Invoice already paid.';
                            break;
                    }
                } else {
                    errorText = result.apiResponse.responseText;
                }

                this.notification.error(errorText);
            }
        }
    }

    async processPaymentCallBack(result) {
        this.alertShow = false;
        this.paymentErrors = [];
        if (
            result.AjaxResponseType === 0 &&
            result.ApiResponseCode === 0 &&
            result.Errors.length === 0
        ) {
            const transactionResult =
                await this.api.postBpointPaymentTransactionResult(
                    result.ResultKey
                );

            this.showPayNowModal = !this.showPayNowModal;
            if (transactionResult.apiResponse.responseCode === 0) {
                if (
                    transactionResult.txnResp.ResponseCode === '0' &&
                    transactionResult.txnResp.BankResponseCode === '00'
                ) {
                    this.paymentComplete(transactionResult);
                } else {
                    this.notification.error(
                        'Payment failed. Please try again.',
                        {
                            timeout: 5000,
                        }
                    );
                    this.alertShow = true;
                    this.alertType = 'danger';
                    this.paymentErrors.push({
                        Message: transactionResult.txnResp.ResponseText,
                    });
                }
            } else {
                this.notification.error(
                    transactionResult.apiResponse.responseText
                );
            }
        } else {
            this.showPayNowModal = !this.showPayNowModal;
            this.alertShow = true;
            this.paymentErrors = result.Errors;
            this.alertType = 'danger';
        }
    }

    addPayment() {
        this.isConfirmPayment = false;
        this.cardProviderType = 'none';
        this.surchargePercentage = 0;
    }

    async paymentComplete(transactionResult) {
        this.appService.storePaymentModel(transactionResult);
        this.notification.success('Thank You! Payment successful', {
            timeout: 5000,
        });
        this.api.postDocPackGeneration({
            Entities: [{entityId: this.appService.policyModel.policyVersionId, sequence: null}],
            SchemeGuid: this.appService.scheme.schemeGuid,
        });
        this.router.load('/complete');
    }

    async reviewPayment() {
        this.alertShow = false;
        this.modalMessage = 'Validating Card Details. Please Wait...';
        this.paymentErrors = [];
        const validationResult = await this.controller.validate();
        if (validationResult.valid) {
            this.showVerifyModal = !this.showVerifyModal;
            const verifyAuthkey = await this.api.postBpointVerifyAuthKey();

            if (verifyAuthkey.apiResponse.responseCode === 0) {
                const verifyResult = await this.api.postBpointVerifyTransaction(
                    verifyAuthkey.authKey,
                    {
                        TxnReq: {
                            Action: 'verify_only',
                            CardDetails: {
                                CardNumber: this.cardNumber,
                                Cvn: this.cardCvn,
                                ExpiryDateMonth: this.cardExpiryMonth,
                                ExpiryDateYear: this.cardExpiryYear,
                                CardHolderName: this.cardName,
                            },
                        },
                    }
                );

                if (verifyResult.APIResponse.ResponseCode === 0) {
                    const verifyTransactionResult =
                        await this.api.postBpointVerifyTransactionResult(
                            verifyResult.ResultKey
                        );

                    if (
                        verifyTransactionResult.apiResponse.responseCode === 0
                    ) {
                        switch (verifyTransactionResult.txnResp.CardType) {
                            case 'MC':
                                this.cardProviderType = 'Mastercard';
                                this.surchargePercentage = 1.15;
                                if (
                                    verifyTransactionResult.txnResp.CardDetails
                                        .SubType === 'debit'
                                ) {
                                    this.cardProviderType = 'MastercardDebit';
                                    this.surchargePercentage = 0.6;
                                }
                                break;
                            case 'VC':
                                this.cardProviderType = 'Visa';
                                this.surchargePercentage = 1.15;
                                if (
                                    verifyTransactionResult.txnResp.CardDetails
                                        .SubType === 'debit'
                                ) {
                                    this.cardProviderType = 'VisaDebit';
                                    this.surchargePercentage = 0.6;
                                }
                                break;
                            case 'AX':
                                this.cardProviderType = 'Amex';
                                this.surchargePercentage = 1.6;
                                break;
                        }
                    }

                    this.surchargeAmount =
                        (this.appService.policyModel.invoiceAmount *
                            this.surchargePercentage) /
                        100;
                    this.totalIncludingSurcharge =
                        this.appService.policyModel.invoiceAmount +
                        this.surchargeAmount;

                    this.isConfirmPayment = true;
                    this.showVerifyModal = !this.showVerifyModal;
                } else {
                    this.showVerifyModal = !this.showVerifyModal;
                    this.alertShow = true;
                    this.alertType = 'danger';
                    this.paymentErrors.push({
                        Message: verifyResult.APIResponse.ResponseText,
                    });
                }
            } else {
                this.showVerifyModal = !this.showVerifyModal;
                this.notification.error(
                    'Card verification failed. Please try again.',
                    {
                        timeout: 5000,
                    }
                );
            }
        }
    }
}

    import { Metadata as $$M } from '@aurelia/metadata';
    import { ExpressionKind as $$EK } from '@aurelia/runtime';
    import { Controller as $$C, CustomElement as $$CE, IHydrationContext as $$IHC } from '@aurelia/runtime-html';

    // @ts-ignore
    const controllers = [];

    // @ts-ignore
    if (module.hot) {

    // @ts-ignore
    module.hot.accept();

    // @ts-ignore
    const hot = module.hot;

    let aurelia = hot.data?.aurelia;

    // @ts-ignore
    document.addEventListener('au-started', (event) => {aurelia= event.detail; });
    const currentClassType = Payment;

    // @ts-ignore
    const proto = Payment.prototype

    // @ts-ignore
    const ogCreated = proto ? proto.created : undefined;

    if (proto) {
      // @ts-ignore
      proto.created = function(controller) {
        // @ts-ignore
        ogCreated && ogCreated.call(this, controller);
        controllers.push(controller);
      }
    }

    // @ts-ignore
    hot.dispose(function (data) {
      // @ts-ignore
      data.controllers = controllers;
      data.aurelia = aurelia;
    });

    if (hot.data?.aurelia) {
      const newDefinition = $$CE.getDefinition(currentClassType);
      $$M.define(newDefinition.name, newDefinition, currentClassType);
      $$M.define(newDefinition.name, newDefinition, newDefinition);
      hot.data.aurelia.container.res[$$CE.keyFrom(newDefinition.name)] = newDefinition;

      const previousControllers = hot.data.controllers ?? [];
      if(previousControllers.length === 0) {
        // @ts-ignore
        hot.invalidate?.();
      }

      // @ts-ignore
      previousControllers.forEach(controller => {
        const values = { ...controller.viewModel };
        const hydrationContext = controller.container.get($$IHC)
        const hydrationInst = hydrationContext.instruction;

        const bindableNames = Object.keys(controller.definition.bindables);
        // @ts-ignore
        Object.keys(values).forEach(key => {
          if (bindableNames.includes(key)) {
            return;
          }
          // if there' some bindings that target the existing property
          // @ts-ignore
          const isTargettedByBinding = controller.bindings?.some(y =>
            y.ast?.$kind === $$EK.AccessScope
              && y.ast.name === key && y.targetProperty
          );
          if (!isTargettedByBinding) {
            delete values[key];
          }
        });
        const h = controller.host;
        delete controller._compiledDef;
        controller.viewModel = controller.container.invoke(currentClassType);
        controller.definition = newDefinition;
        Object.assign(controller.viewModel, values);
        if (controller._hydrateCustomElement) {
          controller._hydrateCustomElement(hydrationInst, hydrationContext);
        } else {
          controller.hE(hydrationInst, hydrationContext);
        }
        h.parentNode.replaceChild(controller.host, h);
        controller.hostController = null;
        controller.deactivate(controller, controller.parent ?? null, 0);
        controller.activate(controller, controller.parent ?? null, 0);
      });
    }
  }